module.exports = __webpack_public_path__ + "static/media/blåbærsyltetøy.c7d16a77.mp3";